"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconStatusExclamation = function IconStatusExclamation(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M27 10V25.3L26.42 32H23.59L23 25.3V10H27Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M25 40C26.6569 40 28 38.6569 28 37C28 35.3431 26.6569 34 25 34C23.3431 34 22 35.3431 22 37C22 38.6569 23.3431 40 25 40Z",
    fill: color
  }));
};

IconStatusExclamation.defaultProps = {
  color: 'black',
  size: 30
};
IconStatusExclamation.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconStatusExclamation;
exports.default = _default;